import * as React from 'react';
import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addGtmScripts } from '../helpers/gtm';
import { State, fetchPublicKeys } from '../slices/publicKeys';

export const GtmWrapper: FC = ({ children }) => {
  const dispatch = useDispatch();
  const { publicKeys } = useSelector((state: { publicKeys: State }) => state.publicKeys);

  useEffect(() => {
    dispatch(fetchPublicKeys());
  }, [dispatch]);

  useEffect(() => {
    if (publicKeys?.googleTagManagerKey) addGtmScripts(publicKeys?.googleTagManagerKey);
  }, [publicKeys]);

  return <>{children}</>;
};
